import React, { type ReactNode, type ComponentType } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import {
	Link,
	type RouteContext,
	RouterSubscriber as RouterSubscriberDI,
	type RouterSubscriberProps,
} from '@atlassian/jira-router';

type Props = Partial<{
	RouterSubscriber: ComponentType<RouterSubscriberProps>;
	to: string;
	children: ReactNode;
	replace: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	style: any;
	innerRef: (ref: HTMLElement | null) => void;
}>;

const KnowledgeHubSpaLink = (props: Props) => {
	const { RouterSubscriber, to, children, innerRef, style, replace } = props;
	// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
	const path = to.charAt(0) === '/' ? to : `/${to}`;
	return __SPA__ ? (
		// @ts-expect-error - TS2604 - JSX element type 'RouterSubscriber' does not have any construct or call signatures.
		<RouterSubscriber>
			{({ match }: RouteContext) =>
				match && match.params && match.params.projectKey ? (
					<Link
						href={`/jira/servicedesk/projects/${match.params.projectKey}${path}`}
						replace={replace}
					>
						{children || null}
					</Link>
				) : null
			}
		</RouterSubscriber>
	) : (
		// @ts-expect-error - TS2769 - No overload matches this call.
		<ReactRouterLink to={to} {...{ innerRef, style }} replace={replace}>
			{children}
		</ReactRouterLink>
	);
};

KnowledgeHubSpaLink.defaultProps = {
	RouterSubscriber: RouterSubscriberDI,
};

export default KnowledgeHubSpaLink;
